module.exports = __webpack_public_path__ + "img/shoot_00031.42fa9b64.png";